// Vendors
import React from 'react'

// Components
import { MotoboyFormNew } from '../form/new'

// Styles
import { LayoutLoggedPageList } from 'layout/PrivatePageList'

import { PageMetaSetting } from './meta'

export const PageUserMotoboyNewRecord = (): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  const { endpoint, title } = PageMetaSetting

  /*
  |-----------------------------------------------------------------------------
  | Renders
  |-----------------------------------------------------------------------------
  |
  |
  */

  return (
    <LayoutLoggedPageList title={title}>
      <MotoboyFormNew endpoint={endpoint} />
    </LayoutLoggedPageList>
  )
}
